export default "__VITE_ASSET__B1u39YaC__"